module.exports = __webpack_public_path__ + "img/testing.35828968.svg";